@if (userLoaded()) {
    <div class="h-dvh w-dvw bg-shui-base-1 flex flex-col overflow-hidden">
        @if (showEnvironmentHint()) {
            <app-banner [stage]="stage"></app-banner>
        }
        <app-header></app-header>
        <main class="flex-1 overflow-hidden min-h-0 box-border">
            <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </div>
    <app-snackbar-container></app-snackbar-container>
} @else {
    <div class="h-dvh w-dvw bg-shui-base-1 flex items-center justify-center">
        <div class="flex flex-col items-center gap-8">
            <img
                src="assets/images/healthineers-logo/healthineers-logo-white.svg"
                alt="Siemens Healthineers"
                class="w-48"
            />
            <sh-spinner size="s"></sh-spinner>
        </div>
    </div>
}
